import React, { useState, useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiBell, FiSearch, FiMonitor, FiWifi } from 'react-icons/fi';

export const Header = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="h-16 bg-chefBlack/80 backdrop-blur-md border-b border-chefPanel/50 flex items-center justify-between px-6 sticky top-0 z-40">
      <div className="flex items-center gap-6">
        <div className="relative hidden lg:block">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-receiptMuted" />
          <input 
            type="text" 
            placeholder="Search orders, tables, prep items..." 
            className="bg-chefDark/50 border border-chefPanel rounded-md py-1.5 pl-9 pr-4 text-xs text-receiptWhite focus:outline-none focus:border-chiliRed transition-all w-80 font-mono" 
          />
        </div>
        <div className="hidden sm:flex items-center gap-2 text-[10px] font-mono text-receiptMuted uppercase tracking-widest">
           <SafeIcon icon={FiWifi} className="text-status-open" />
           <span>Sync Active</span>
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="font-mono text-receiptMuted text-right hidden xs:flex flex-col">
          <span className="text-receiptWhite text-sm font-bold tracking-tighter">
            {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}
          </span>
          <span className="text-[9px] uppercase tracking-widest opacity-60">Ops Terminal 01</span>
        </div>

        <div className="flex items-center gap-3 border-l border-chefPanel pl-6">
          <button className="relative text-receiptMuted hover:text-receiptWhite transition-colors p-1.5 hover:bg-chefPanel rounded-md">
            <SafeIcon icon={FiBell} className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-chiliRed rounded-full border-2 border-chefBlack"></span>
          </button>
          
          <div className="flex items-center gap-3 ml-2">
            <div className="flex flex-col items-end leading-none hidden md:flex">
              <span className="text-xs text-receiptWhite font-bold">Chef Marco</span>
              <span className="text-[9px] text-chiliRed font-mono uppercase">Expeditor</span>
            </div>
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-chiliRed to-chiliDark border border-chiliRed/30 flex items-center justify-center text-xs font-black text-white shadow-glow-red/20">
              CM
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};